import { createFileRoute } from "@tanstack/react-router";
import UKUlezCompliant from "@/pages/landing/UKUlezCompliant";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/ulez-compliant-cars/")({
  head: () => routeHead("/uk/ulez-compliant-cars/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UKUlezCompliant />
  );
}
